/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_ResultInputs */

const en_wb_sales_result = /** @type {(inputs: Wb_Sales_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The original enquiry, account history and calendar come together in one draft.`)
};

const lv_wb_sales_result = /** @type {(inputs: Wb_Sales_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sākotnējais pieprasījums, klienta vēsture un kalendārs satiekas vienā melnrakstā.`)
};

/**
* | output |
* | --- |
* | "The original enquiry, account history and calendar come together in one draft." |
*
* @param {Wb_Sales_ResultInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_result = /** @type {((inputs?: Wb_Sales_ResultInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_ResultInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_result(inputs)
	return en_wb_sales_result(inputs)
});